import React from 'react';
import './Solutions.css';
import SolutionsHeroSection from '../components/SolutionsHeroSection';
import csrIcon from '../assets/icons/nh-icon-csr.png';
import triageIcon from '../assets/icons/nh-icon-triage.png';
import selfCareIcon from '../assets/icons/nh-icon-selfcare.png';
import notesAiIcon from '../assets/icons/nh-icon-notes-ai.png';

function Solutions() {
  return (
    <div>
      {/* Hero Section */}
      <SolutionsHeroSection />

      {/* Solutions Overview */}
      <section className="solutions-overview">
        <div className="solutions-grid">
          {/* AI CSR */}
          <div className="solution-card">
            <div className="solution-header">
              <img src={csrIcon} alt="SmartAssist AI" className="solution-icon" />
              <h3>SmartAssist AI</h3>
            </div>
            <p>
              Revolutionize customer service with AI-powered automation across multiple channels, including VOIP, chat, and WhatsApp.
            </p>
            <ul>
              <li><strong>24/7 Availability:</strong> Provide round-the-clock support to your customers.</li>
              <li><strong>Personalized Interactions:</strong> Tailor responses based on customer preferences and history.</li>
              <li><strong>Cost Efficiency:</strong> Reduce operational costs while improving response times.</li>
            </ul>
          </div>

          {/* Pet Triage System */}
          <div className="solution-card">
            <div className="solution-header">
              <img src={triageIcon} alt="Pet Triage System" className="solution-icon" />
              <h3>VetAI Triage</h3>
            </div>
            <p>
              Enhance veterinary care with AI-driven triage recommendations based on pet medical history.
            </p>
            <ul>
              <li><strong>Data-Driven Insights:</strong> Utilize pet medical records for informed decision-making.</li>
              <li><strong>Emergency Prioritization:</strong> Quickly identify critical cases.</li>
              <li><strong>Improved Outcomes:</strong> Streamline workflows for veterinarians and pet owners.</li>
            </ul>
          </div>

          {/* Self-Care AI */}
          <div className="solution-card">
            <div className="solution-header">
              <img src={selfCareIcon} alt="Self-Care AI" className="solution-icon" />
              <h3>EmpowerAI Self-Service</h3>
            </div>
            <p>
              Enable customers to take control with self-service tools integrated with CRM, billing, and order management systems.
            </p>
            <ul>
              <li><strong>Streamlined Processes:</strong> Simplify account management, order placement, and payments.</li>
              <li><strong>Enhanced Customer Satisfaction:</strong> Provide a user-friendly self-service experience.</li>
              <li><strong>Scalable Solution:</strong> Handle high volumes of customer requests effortlessly.</li>
            </ul>
          </div>

          {/* Patient Notes AI */}
          <div className="solution-card">
            <div className="solution-header">
              <img src={notesAiIcon} alt="Patient Notes AI" className="solution-icon" />
              <h3>MediNotes AI</h3>
            </div>
            <p>
            Simplify healthcare documentation with AI-powered assistance for patient interactions, referrals, and scheduling.
            </p>
            <ul>
              <li><strong>Automated Documentation:</strong> Save time by automating patient interaction notes.</li>
              <li><strong>Integrated Systems:</strong> Seamlessly connect with IMIR (Intelligent Medical Information Repository).</li>
              <li><strong>Comprehensive Support:</strong> Write referrals, schedule appointments, and document medical events effortlessly.</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Solutions;